function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M23.38,0H.38A.38.38,0,0,0,0,.38v23a.38.38,0,0,0,.38.37h23a.38.38,0,0,0,.37-.37V.38A.38.38,0,0,0,23.38,0ZM23,23H.75V.75H23ZM6,5.38A.38.38,0,0,1,6.38,5h14a.38.38,0,0,1,0,.75h-14A.38.38,0,0,1,6,5.38Zm-3,3A.38.38,0,0,1,3.38,8h17a.38.38,0,0,1,0,.75h-17A.38.38,0,0,1,3,8.38Zm0,3A.38.38,0,0,1,3.38,11h17a.38.38,0,0,1,0,.75h-17A.38.38,0,0,1,3,11.38Zm0,3A.38.38,0,0,1,3.38,14h17a.38.38,0,0,1,0,.75h-17A.38.38,0,0,1,3,14.38Zm0,3A.38.38,0,0,1,3.38,17h7a.38.38,0,0,1,0,.75h-7A.38.38,0,0,1,3,17.38Z"
})));

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.75 23.75",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.b1b2eb25.svg";
export { ForwardRef as ReactComponent };